<template>
  <div class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <div
      style="/*  */width: .75rem;height: .1979rem;color: rgb(0, 0, 0);font-family: 苹方;font-size: .1875rem;font-weight: 400;line-height: .1979rem;letter-spacing: 0rem;text-align: left;">
      我的预约</div>
    <Jianli v-if="this.teacherID" :tid="teacherID" :button="[false, true]"
      style="width:3.75rem;height:auto;position:absolute;box-shadow: 0 0 .1042rem rgba(0, 0, 0, .25);padding: .1042rem .1042rem .3125rem .2083rem; z-index: 9;background-color: #fff;top: .7813rem;">
    </Jianli>
    <img v-if="this.teacherID" src="../../assets/close.png" @click="teacherID = ''"
      style=" width: .0521rem;height: .0521rem;position:absolute; top: .9375rem;left: 7.2688rem; z-index: 1000;" alt="">
    <!-- 正文 -->
    <div>
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" active-text-color="#01A299">
        <el-menu-item index="1" @click="select('all')">全部</el-menu-item>
        <el-menu-item index="2" @click="select(3)">预约中</el-menu-item>
        <el-menu-item index="3" @click="select(4)">预约成功</el-menu-item>
        <el-menu-item index="4" @click="select(5)">预约失败</el-menu-item>
      </el-menu>
      <div style="width: 4.5833rem;display: flex;flex-wrap: wrap;justify-content: space-between; " class="dingdan">
        <div class="father" v-for="item in total">
          <div>
            <div class="ed-succes" v-if="item.contractStatus == 5">预约成功 <img src="../../assets/Sdingdansucces.png"
                alt="" style="transform: translateY(.026rem);"></div>
            <div v-else-if="item.contractStatus == 4" class="ed-ed">
              <div>预约失败 <img src="../../assets/Syuyuefailed.png" alt="" style="transform: translateY(.0208rem);"></div>
              <el-popover placement="top" trigger="click">
                <el-button slot="reference" style="line-height: .026rem;padding-left: .0781rem;">联系客服</el-button>
                <span style="position: relative;top: -0.1563rem;">扫码添加客服微信</span>
                <img src="../../assets/二维码.png" style="width: .4167rem;height: .4167rem;" alt="">
              </el-popover>
            </div>
            <div v-else-if="item.contractStatus == 1" class="ed-succes" style="color: black;">
              预约中
            </div>
            <div class="line"></div>
            <div class="dd">
              <div class="flex">
                <div class="box">
                  <div class="inner">
                    <div class="left">
                      <img :src="'https://www.cdjjwang.com/' + item.parentVerifiedTeacherVO.avatar" alt="">
                      <div class="name">{{ item.parentVerifiedTeacherVO.name }}</div>
                    </div>
                    <div class="right">
                      <div class="time"><img src="../../assets/indexFTboxtimer.png" alt="">累计授课{{
      item.parentVerifiedTeacherVO.classHours }}h
                      </div>
                      <div class="card">
                        <div>{{ item.parentVerifiedTeacherVO.university }}</div>
                        <div>{{ teachertype[item.parentVerifiedTeacherVO.collegeStudentGrade] }}</div>
                      </div>
                      <div class="txt">{{ item.parentVerifiedTeacherVO.selfEvaluation }}</div>
                      <button @click="teacherID = item.contractTid">查看详情</button>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>

      </div>
    </div>

  </div>
</template>
<style>
.judge {
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  height: 180px;
  border: 1px solid rgb(220, 223, 230);
  border-radius:
    4px;
  outline: none;
  padding: 10px 10px 10px 10px;
  /* 请输入 */
  color: rgb(59, 60, 63);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.01px;
  text-align: left;
}

.judgeconfirm {
  /* button/default/default/none/on/off (style) */
  width: 60px;
  height: 32px;
  background: rgb(1, 149, 146) !important;
  border-radius:
    4px;
  /* 提 交 */
  color: rgb(255, 255, 255);
  font-family: 苹方;
  font-size: 14px !important;
  font-weight: 400;
  line-height: 2px !important;
  letter-spacing: -0.01px;
  text-align: center;
  transform: translateX(-280%);

}
</style>
<script>
import Jianli from '../layout/Slookteacherjianli.vue'
export default {
  components: {
    Jianli
  },
  data() {
    return {
      teacherID: '',
      activeIndex: '1',
      Smallstausbar: 's',
      total: [],
      teachertype: ['专职教师', '在读本科生', '在读研究生'],
    }
  },
  methods: {
    select(n) {
      if (n == 'all') {
        this.$http.get('/Api/Parent/Demands', {
          params: {
            pageNumber: 1,
            pageSize: 999,
            type: 2
          },
          headers: {
            'Authorization': localStorage.getItem('Authorization')
          }
        }).then(res => {
          console.log(res.data.data.records);
          this.total = res.data.data.records
        })
      }
      else {
        this.$http.get('/Api/Parent/Demands', {
          params: {
            pageNumber: 1,
            pageSize: 999,
            type: 2,
            status: n
          },
          headers: {
            'Authorization': localStorage.getItem('Authorization')
          }
        }).then(res => {
          console.log(res.data.data.records);
          this.total = res.data.data.records
        })
      }

    }
  },
  created() {
    this.$http.get('/Api/Parent/Demands', {
      params: {
        pageNumber: 1,
        pageSize: 999,
        type: 2
      },
      headers: {
        'Authorization': localStorage.getItem('Authorization')
      }
    }).then(res => {
      console.log(res.data.data.records);
      this.total = res.data.data.records
    })
  }
}
</script>

<style scoped>
.dingdan .father {
  width: 420px;
  height: 292px;
  background: rgb(255, 255, 255);
  box-shadow: 0px 0px 4px 5px rgba(0, 0, 0, 0.07);
  border-radius: 2px;
  margin-top: 40px;
}

.dd .flex .box {
  width: 430px;
  height: 300px;
  margin-top: 20px;
}

.dd .flex .box .inner {
  display: flex;
  width: 360px;
  height: 212px;
  margin: 0 auto;
  justify-content: space-between;
}

.dd .flex .box .inner .left img {
  width: 120px;
  height: 180px;
}

.dd .flex .box .inner .left .name {
  /* tag/default/default/plain/off (style) */
  width: 120px;
  height: 24px;
  box-sizing: border-box;
  border: 1px solid rgb(1, 162, 153);
  border-radius:
    2px;
  margin-top: 8px;
  /* 弗拉基米·伊里奇 */
  color: rgb(1, 162, 153);
  font-family: 苹方;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  letter-spacing: 1px;
}

.dd .flex .box .inner .right {
  width: 224px;
  height: 212px;
}

.dd .flex .box .inner .right .time {
  width: 140px;
  height: 24px;
  box-sizing: border-box;
  border: 1px solid rgb(1, 162, 153);
  border-radius:
    2px;
  /* 累计授课1145h */
  color: rgb(1, 162, 153);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: center;
}

.dd .flex .box .inner .right .time img {
  width: 12px;
  height: 14px;
  transform: translateY(2px);
  margin-right: 5px;
}

.dd .flex .box .inner .right .card {
  width: 224px;
  height: 20px;
  display: flex;
  gap: 8px;
  overflow: hidden;
  flex-wrap: wrap;
  margin-top: 10px;
}

.dd .flex .box .inner .right .card div {
  width: auto;
  height: 24px;
  padding-left: 5px;
  padding-right: 5px;
  /* 下北泽大学 */
  color: rgb(1, 162, 153);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  background: rgb(207, 242, 240);
  border-radius:
    2px;

}

.dd .flex .box .inner .right .txt {
  /* 矩形 32 */
  width: 224px;
  height: 108px;
  background: rgb(255, 255, 255);
  border: 1px dashed rgb(205, 208, 214);
  border-radius:
    2px;
  margin-top: 9px;
  padding: 4px 7px 4px 7px;
  color: rgb(96, 98, 102, 0.85);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: justify;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  /* 限制在一个块元素显示的文本的行数 */
  -webkit-box-orient: vertical;
  /* 设置或检索伸缩盒对象的子元素的排列方式 */
  overflow: hidden;
}

.dd .flex .box .inner .right button,
.ed-ed button {
  width: 80px;
  height: 32px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  border: none;
  /* Small Button */
  color: rgb(255, 254, 254);
  font-family: Microsoft YaHei;
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
  margin-left: 144px;
  margin-top: 8px;
}

.ed-succes {
  /* 匹配成功 */
  width: 139px;
  height: 38px;
  /* 匹配成功 */
  color: rgb(103, 194, 58);
  font-family: 苹方;
  font-size: 24px;
  font-weight: 400;
  line-height: 38px;
  text-align: left;
  margin-top: 8px;
  margin-left: 32px;
}

.ed-ed {
  height: 38px;
  width: 365px;
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  margin-left: 32px;
  position: relative;
}

.ed-ed::after {
  content: '请联系平台客服为您匹配合适的老师';
  /* 请联系平台客服为您匹配合适的老师 */
  position: absolute;
  top: 36px;
  width: 271px;
  height: 37px;
  color: rgb(245, 108, 108, .8);
  font-family: 苹方;
  font-size: 10px;
  font-weight: 400;
  line-height: 38px;
  letter-spacing: 0px;
  text-align: left;
}

.ed-ed div {
  /* 已结束 */
  height: 38px;
  color: #F56A6A;
  font-family: 苹方;
  font-size: 24px;
  font-weight: 400;
  line-height: 38px;
  letter-spacing: 0px;
  text-align: left;
}

.father .line {
  /* Line */
  width: 420px;
  height: 1px;
  background: rgb(220, 223, 230);
  border-radius:
    2px;
  margin-top: 6px;
  margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/studentyuyue.vue